import { useState } from 'react';
import { UnitCategoryCode, PurchasableFund } from 'funds-model';

const sortBy = (a: string | number | undefined, b: string | number | undefined, direction: string) => {
  if (a == null && b == null) {
    return 0;
  }
  if (a == null || (b != null && a < b)) {
    return direction === 'asc' ? -1 : 1;
  }
  if (b == null || a > b) {
    return direction === 'asc' ? 1 : -1;
  }
  return 0;
};

const getSortedFunds = (funds: PurchasableFund[] | undefined, sortConfig: { key: string, direction: string }, rateKey: string, unitCategoryCode: UnitCategoryCode) => {

  if (!funds) {
    return undefined;
  }

  const sortedFunds = [...funds];

  switch (sortConfig.key) {
    case 'name':
      sortedFunds.sort((a, b) => {
        const comparison = a.name.localeCompare(b.name);
        return sortConfig.direction === 'asc' ? comparison : -comparison;
      });
      break;
    case 'fundType':
      sortedFunds.sort((a, b) => sortBy(a.fundType?.name.toLowerCase(),
          b.fundType?.name.toLowerCase(),
          sortConfig.direction));
      break;
    case 'risk':
      sortedFunds.sort((a, b) => sortBy(a.risk?.value, b.risk?.value, sortConfig.direction));
      break;
    case 'pricing':
      sortedFunds.sort((a, b) => (
        sortBy(a.quotesForUnitCode[unitCategoryCode]?.value, b.quotesForUnitCode[unitCategoryCode]?.value, sortConfig.direction))
      );
      break;
    case 'roi':
      sortedFunds.sort((a, b) => (
        sortBy(a.quotesForUnitCode[unitCategoryCode]?.changes[rateKey], b.quotesForUnitCode[unitCategoryCode]?.changes[rateKey], sortConfig.direction))
      );
      break;
    case 'horizon':
      sortedFunds.sort((a, b) => (
          sortBy(a.horizonValue, b.horizonValue, sortConfig.direction))
      );
      break;
    default:
      return sortedFunds;
  }
  return sortedFunds;
};

export type SortDirection = 'asc' | 'desc';

const useSortState = () => {
  const [sortConfig, setSortConfig] = useState({ key: 'name', direction: 'asc' });
  const [isInitialSort, setIsInitialSort] = useState(true);

  const requestSort = (key: string, direction?: SortDirection) => {
    let directionInner = direction || 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      directionInner = 'desc';
    }
    setSortConfig({ key, direction: directionInner });
    setIsInitialSort(false);
  };

  return { sortConfig, requestSort, getSortedFunds, isInitialSort };
};

export { useSortState, sortBy };
